export default "__VITE_PUBLIC_ASSET__dc286520__"